export default __webpack_public_path__ + "media/images/user_photos/113-decd8b7389443c660304f05c5f823a70.jpg";